export const styles = {
	paper: {
		position: 'absolute',
		zIndex: 3,
		width: '99%',
		height: '99%',
		opacity: 0.8,
		overflow: 'hidden'
	},
	ghost: {
		position: 'absolute',
		top: 0,
		left: 0,
		right: 0,
		bottom: 0
	},

	centered: {
		height: '100%',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center'
	},
	fabProgress: {
		color: 'primary.main',
		zIndex: 1
	}
};
